<template>
	<!-- 登录页面 -->
	<div class="loginBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">注册</p>
				</div>
			</div>
		</van-sticky>
		<div class="banner">
			<div class="headerImg"><img src="../../assets/img/logo.png" alt=""></div>
		</div>
		<!-- 表单 -->
		<div class="fromBox">
			<form>
				<div class="phoneBox">
					<img src="../../assets/img/phoneIcon.png" alt="" class="phoneIcon">
					<input type="text" placeholder="请输入手机号" v-model="userName">
				</div>
				<div class="phoneBox yanzhengma">
					<img src="../../assets/img/phoneIcon.png" alt="" class="phoneIcon">
					<input type="text" placeholder="请输入验证码" maxlength="6" v-model="valueYzm">
					<span class="yanzhengmaTxt" v-show="show" @click="getCode">获取验证码</span>
					<span class="yanzhengmaTxt" v-show="!show">{{count}}s后可重试</span>
				</div>
				<div class="phoneBox passwordBox">
					<img src="../../assets/img/passwordIcon.png" alt="" class="phoneIcon">
					<input type="password" placeholder="请输入密码(字母加数字组合6—18位)" maxlength="18" v-model="passwordValue" v-if="!passwordShow">
					<input type="text" placeholder="请输入密码(字母加数字组合6—18位)" maxlength="18" v-model="passwordValue" v-if="passwordShow">
					<img src="../../assets/img/esy.png" alt="" class="esyIcom" @click.stop="esyHide" v-if="passwordShow"/>
					<img src="../../assets/img/esy_icon02.png" alt="" class="esyIcom" @click.stop="esyShow" v-if="!passwordShow"/>
				</div>
				<div class="phoneBox queryPassword">
					<img src="../../assets/img/passwordIcon.png" alt="" class="phoneIcon">
					<input type="password" placeholder="请再次输入密码(字母加数字组合6—18位)" maxlength="18" v-model="queryPassword">
				</div>
				<div class="submitBox">
					<button class="submit" @click.prevent="registBtnFn(userName,valueYzm,passwordValue,queryPassword)">注册</button>
				</div>
				<div class="login_type">
					<!--  @click="phoneRegist" -->
					<span class="active">手机号注册</span>
					<span @click="emailPenRegist">邮箱注册</span>
				</div>
				<p class="promptLanguage">
					<span class="male">
						<input type="checkbox" id="male1" name="zhifuType" :checked="checked" @change="registCheckFn(checked)"/>
						<label for="male1"></label>
					</span>
				<span @click="privacyAgreementFn">选中登录后代表您已同意《云锦文学城用户隐私协议》</span>、<span @click="registXyFn">《云锦文学城用户注册协议》</span></p>
			</form>
		</div>
		<!-- 快捷登陆 -->
		<div class="kjLogin">
			<p class="kjTxt">快捷登陆</p>
			<div class="loginIcon">
				<div @click="getVersion">
					<img src="../../assets/img/weixin.png" alt="">
				</div>
				<div>
					<img src="../../assets/img/weibo.png" alt="">
				</div>
				<div @click="getQQVersion">
					<img src="../../assets/img/QQ.png" alt="">
				</div>
				<div>
					<img src="../../assets/img/zhifubao.png" alt="">
				</div>
			</div>
		</div>
    <van-popup v-model="showPopup" position="bottom" :style="{ height: '90%' }">
      <privacy-agreement @closePopup="showPopup=false"></privacy-agreement>
    </van-popup>
	</div>
</template>

<script>
	import {
		SOME_RULES
	} from '@/utils/rules.js';
	import {Toast} from 'vant';
  import PrivacyAgreement from "@/components/privacyAgreement.vue";
	export default {
    components: {
      PrivacyAgreement
    },
		data() {
			return {
				userName: '', //用户名
				valueYzm: '', //验证码
				passwordValue: '', //密码
				queryPassword: '', //确认密码
				passwordShow: false,//默认闭眼
				show: true,
				count: '',
				timer: null,
				disabled: true,
				checked:false,
        showPopup: false
			}
		},
		created() {
			if (this.$webapp.isAndroid) {
				console.log("安卓")
				let isdark = 1;
				this.range = window.android.setBarcolor(Boolean(isdark)); //获取亮度 --- 安卓
			} else if (this.$webapp.isiOS) {
				console.log("苹果")
				// window.webkit.messageHandlers.loginwx.postMessage('') // 苹果
			}
		},
		methods: {

			registCheckFn(check){
				if(check == false){
					this.checked = true
				}else{
					this.checked = false
				}
			},
			esyHide(){
				//睁眼
				this.passwordShow = !this.passwordShow;
			},
			esyShow(){
				//闭眼
				this.passwordShow = !this.passwordShow;
			},
			registXyFn() {
				this.$router.push('/registXy')
			},
			privacyAgreementFn(){
        this.showPopup = true;
				// this.$router.push('/privacyAgreement')
			},
			phoneRegist(){ //手机号注册
				this.$router.push('/regist')
			},
			emailPenRegist(){ //邮箱笔名注册
				this.$router.push('/emailRegist')
			},
			// 验证码 接口
			getCode() {
				const TIME_COUNT = 60;
				this.disabled = false;
				if (SOME_RULES.phone.test(this.userName.trim()) == false) {
					Toast('手机号不为空')
					return false
				} else {
					this.$axios.get(`${this.$api.send_code}?mobile= ${this.userName}&type=1`).then((response) => {
						Toast(response.data.msg)
					})
				}
				if (!this.timer) {
					this.count = TIME_COUNT;
					this.show = false;
					this.timer = setInterval(() => {
						if (this.count > 0 && this.count <= TIME_COUNT) {
							this.count--;
						} else {
							this.show = true;
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 1000)
				}
			},
			//注册信息提交
			registBtnFn(userName, valueYzm, passwordValue, queryPassword) {
				let registerValue = {
					account: this.userName,
					password: this.passwordValue,
					repeat_pwd: this.queryPassword,
					type: 1,
					sms_code: this.valueYzm
				}
				if (this.userName == '') {
					Toast('手机号不为空')
					return false
				}else if (SOME_RULES.phone.test(this.userName.trim()) == false) {
					Toast('请输入正确的手机号')
					return false
				}else if(SOME_RULES.password.test(this.passwordValue.trim()) == false){
					Toast('请输入密码(字母加数字组合6—18位)');
				  return false
				}else if(SOME_RULES.password.test(this.queryPassword.trim()) == false){
					Toast('请输入密码(字母加数字组合6—18位)');
				  return false
				}else if(this.valueYzm == ''){
					Toast('请输入验证码')
					return false
				}else if (this.queryPassword != this.passwordValue){
					Toast('两次密码不一致')
					return false
				}else if(this.checked == false){
					Toast('请先选中用户隐私政策和云锦书城用户注册协议')
					return false
				}else {
					console.log(registerValue,'registerValue')
					this.$axios.post(this.$api.register, registerValue).then((response) => {
						Toast(response.data.msg);
						var that = this;
						if(response.data.code == 0){
							return false;
						}else if(response.data.code == 1){
							setTimeout(function() {
								that.$router.push('/login')
							}, 500)
						}
					})
				}
			},
			back() {
				this.$router.push('/userinfo')
			},
			getVersion() {
				if (this.$webapp.isAndroid) {
					console.log("安卓")
					window.android.loginwx(); //安卓
				} else if (this.$webapp.isiOS) {
					console.log("苹果")
					// window.webkit.messageHandlers.loginwx.postMessage('') // 苹果
				}
				// alert(this.codeStr); 暴露方法 
			},
			getQQVersion(){
				if (this.$webapp.isAndroid) {
					console.log("安卓")
					window.android.qqLogin() //安卓
				} else if (this.$webapp.isiOS) {
					console.log("苹果")
					// window.webkit.messageHandlers.loginwx.postMessage('') // 苹果
				}
				// alert(this.codeStr); 暴露方法 
			},
			// 微信请求
			resultCode(code) {
				localStorage.setItem('codeWeiXin', code);
				if (code != null) {
					Toast('准备好 请求了');
					this.$axios.post(this.$api.wechat_login, {
						code: localStorage.getItem('codeWeiXin')
					}).then(res => {
						localStorage.setItem('userInfo', JSON.stringify(res.data.data.userinfo) ? JSON.stringify(res.data
							.data.userinfo) : null);
						localStorage.setItem('userInfoData', JSON.stringify(res.data.data.userinfo) ? JSON.stringify(res.data
							.data.userinfo) : null);
						this.$axios.defaults.headers = {
							"token": JSON.parse(localStorage.getItem('userInfoData')).token,
							"content-type": 'application/json; charset=utf-8',
						}
						Toast('授权成功');
						this.$router.push('/userinfo')
					}).catch(() => alert('promise catch err'));
				}
			},
			qqResultCode(json){
				let qqCode = json.split(',');
				if (json != null) {
					Toast('准备好 请求了');
					this.$axios.post(this.$api.qq_login, {
						openid: qqCode[0],
						access_token: qqCode[1],
					}).then(res => {
						localStorage.setItem('userInfo', JSON.stringify(res.data.data.userinfo) ? JSON.stringify(res.data
							.data.userinfo) : null);
						localStorage.setItem('userInfoData', JSON.stringify(res.data.data.userinfo) ? JSON.stringify(res.data
							.data.userinfo) : null);
						this.$axios.defaults.headers = {
							"token": JSON.parse(localStorage.getItem('userInfoData')).token,
							"content-type": 'application/json; charset=utf-8',
						}
						Toast('QQ授权成功');
						this.$router.push('/userinfo')
					}).catch(() => alert('promise catch err'));
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.loginBox {
		height: 100vh;
		background-color: #fff;
		overflow-x: hidden;
		overflow-y: scroll;
		color: #000;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ffffff;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 20px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;


				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 10px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}

		}

		//登录头像
		.banner {
			position: relative;
			height: 300px;
			background-color: #fff;

			.headerImg {
				img {
					width: 160px;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
				}
			}
		}

		//表单
		.fromBox {
			background-color: #fff;
			padding: 0 30px;

			form {
				img {
					width: 60px;
				}

				//手机号、邮箱 笔名
				.phoneBox {
					border: 1px solid #ccc;
					/*no*/
					border-radius: 80px;
					height: 80px;
					margin-bottom: 40px;
					position: relative;
					padding: 0 20px;

					.phoneIcon {
						position: absolute;
						top: 50%;
						left: 35px;
						transform: translateY(-50%);
						width: 30px;
					}

					input {
						position: absolute;
						left: 100px;
						height: 60px;
						width: calc(100% - 140px);
						padding: 10px 0;
						background-color: transparent;
					}
				}

				//验证码
				.yanzhengma {
					position: relative;

					.yanzhengmaTxt {
						line-height: 80px;
						color: #ff4081;
						position: absolute;
						top: 50%;
						right: 40px;
						transform: translateY(-50%);
						background-color: #fff;
					}
				}

				//输入密码
				.passwordBox {
					position: relative;

					.phoneIcon {
						width: 40px;
						left: 30px;
					}

					.esyIcom {
						position: absolute;
						top: 50%;
						right: 40px;
						transform: translateY(-50%);
						width: 40px;
					}
				}

				//确认密码
				.queryPassword {
					position: relative;

					.phoneIcon {
						position: absolute;
						top: 50%;
						left: 30px;
						transform: translateY(-50%);
						width: 40px;
					}
				}

				//注册按钮
				.submitBox {
					width: 100%;

					.submit {
						width: 100%;
						border: 0;
						height: 85px;
						border-radius: 85px;
						// 渐变色
						background-image: linear-gradient(#ff6c9e,#ff699d, #ff4785);
						color: #ffffff;
						font-size: 36px;
						/*px*/
					}
				}
				//登录方式
				.login_type {
					width: 500px;
					margin: 0 auto;
					display: flex;
					line-height: 60px;
					padding-top: 20px;
					span {
						flex: 1;
						text-align: center;
						font-size: 32px;
						/*px*/
					}
				
					span.active {
						color: #fa7298;
					}
				}
				//提示语
					.promptLanguage {
						font-size: 22px;
						/*px*/
						padding-top: 20px;
						color: #a3a3a3;
						// text-align: center;
						padding-left: 30px;
						.male{
							display: inline-block!important;
							input[type="checkbox"]+label::before {
								content: "\a0";
								/*不换行空格*/
								display: inline-block;
								vertical-align: middle;
								font-size: 18px;
								width: 1em;
								height: 1em;
								margin-right: .4em;
								border-radius: 50%;
								border: 2px solid #e5e5e5;
								/*no*/
								text-indent: .15em;
								line-height: 1;
								padding: .2em;
							}
							
							input[type="checkbox"]:checked+label::before {
								background-color: #ff7089;
								border: 2px solid #ff7089;
								/*no*/
								background-clip: content-box;
								padding: .2em;
							}
							
							input[type="checkbox"] {
								position: absolute;
								clip: rect(0, 0, 0, 0);
							}
							
						}
					}
				
			}
		}

		//快捷登录方式
		.kjLogin {
			padding: 40px 0;

			.kjTxt {
				text-align: center;
				line-height: 60px;
				color: #aaaaaa;
				font-size: 32px;
				/*px*/
				width: 50%;
				position: relative;
				margin: 0 auto;
			}

			.kjTxt::before {
				content: '';
				width: 100px;
				height: 4px;
				/*px*/
				background-color: #f0f0f0;
				position: absolute;
				left: 0;
				top: 50%;
				transform: translateY(-50%);
			}

			.kjTxt::after {
				content: '';
				width: 100px;
				height: 4px;
				/*px*/
				background-color: #f0f0f0;
				position: absolute;
				right: 0;
				top: 50%;
				transform: translateY(-50%);
			}

			.loginIcon {
				width: 80vw;
				margin: 0 auto;
				display: flex;
				margin-top: 30px;

				div {
					flex: 1;
					text-align: center;

					img {
						width: 60px;
					}
				}
			}
		}

	}
</style>
